import { NavigationView } from '@/shared/constants/navigation-view.enum';

/** Simulador de folha: apenas Administrador e Recursos Humanos. */
export function podeAcessarSimuladorFolha(
  view: NavigationView | null | undefined,
): boolean {
  return (
    view === NavigationView.Administrador ||
    view === NavigationView.RecursosHumanos
  );
}
